import {
	useState,
	useEffect,
} from "react";
import {
	Box,
	Typography,
	Paper,
	IconButton,
	TextField,
	Button,
	Divider,
	Modal,
} from '@mui/material';
import { LoadingButton } from '@mui/lab'
import DataFileService from '../../../services/DataFileService'
import GlobalTip from '../../../providers/GlobalTip'

const jss = {
	modal: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 400,
		bgcolor: 'background.paper',
		p: 2,
	}
}

function SettingModal(props) {
	const {client} = props
	const [periodStart, setPeriodStart] = useState('');
	const [months, setMonths] = useState('');
	const [unfinalizeStart, setUnfinalizeStart] = useState('');
	const [unfinalizeEnd, setUnfinalizeEnd] = useState('');
	const [unfinalizing, setUnifinalizing] = useState(false)
	const [errors, setErrors] = useState({
		periodStart: false,
		months: false,
		unfinalizeStart: false,
		unfinalizeEnd: false,
	})
	const [backdating, setBackdating] = useState(false)
	const [perpetuating, setPerpetuating] = useState(false)
	const tipContext = GlobalTip.useMessage()

	async function batchUnfinalize() {
		if( !unfinalizeStart ) {
			setErrors({...errors, unfinalizeStart:true})
			return
		}
		if( !unfinalizeEnd ) {
			setErrors({...errors, unfinalizeEnd:true})
			return
		}
		try {
			setUnifinalizing(true)
			await DataFileService.batchUnfinalize(client.Id, unfinalizeStart, unfinalizeEnd)
			props.onClose()
			props.onRefreshDataFiles()
			tipContext.showSuccess()
		} catch(e) {
		}
		setUnifinalizing(false)
	}

	async function backdate() {
		try {
			setBackdating(true)
			await DataFileService.backdate(client.Id, periodStart, months)
			tipContext.showSuccess()
			props.onClose()
			props.onRefreshDataFiles()
		} catch(e) {
			tipContext.show(e.message)
		}
		setBackdating(false)
	}

	async function perpetuate() {
		try {
			setPerpetuating(true)
			await DataFileService.perpetuate(client.Id, periodStart, months)
			tipContext.showSuccess()
			props.onClose()
			props.onRefreshDataFiles()
		} catch(e) {
			tipContext.show(e.message)
		}
		setPerpetuating(false)
	}

	return (
		<Modal
			{...props}
		>
			<Paper sx={jss.modal}>
				<Typography variant="h6">Adjust inventory</Typography>
				<TextField 
					label="Period start"
					value={periodStart}
					error={errors.periodStart}
					onChange={e => {
						setPeriodStart(e.target.value)
						setErrors({...errors, periodStart:false})
					}}
					size="small"
					fullWidth
					type="number"
					sx={{mt:2}}
					placeholder='E.g. "202205"'
					inputProps={{
						maxLength: 6
					}}
				/>
				<TextField 
					label="Months"
					value={months}
					error={errors.months}
					onChange={e => {
						setMonths(e.target.value)
						setErrors({...errors, months:false})
					}}
					size="small"
					fullWidth
					type="number"
					sx={{mt:2}}
					inputProps={{
						maxLength: 2
					}}
				/>
				<Box sx={{mt:2, display:'flex'}}>
					<LoadingButton loading={backdating} sx={{mr:1,}} variant="contained" fullWidth onClick={backdate}>Backdate</LoadingButton>
					<LoadingButton loading={perpetuating} sx={{ml:1,}} variant="contained" fullWidth onClick={perpetuate}>Perpetuate</LoadingButton>
				</Box>
				<Divider sx={{my:2}}/>
				<Box sx={{display:'flex'}}>
					<TextField 
						label="Unfinalize period start"
						value={unfinalizeStart}
						error={errors.unfinalizeStart}
						onChange={e => {
							setUnfinalizeStart(e.target.value)
							setErrors({...errors, unfinalizeStart:false})
						}}
						size="small"
						fullWidth
						type="number"
						sx={{mr:1}}
						placeholder='E.g. "202205"'
						inputProps={{
							maxLength: 6
						}}
					/>
					<TextField 
						label="Unfinalize period end"
						value={unfinalizeEnd}
						error={errors.unfinalizeEnd}
						onChange={e => {
							setUnfinalizeEnd(e.target.value)
							setErrors({...errors, unfinalizeEnd:false})
						}}
						size="small"
						fullWidth
						type="number"
						sx={{ml:1}}
						placeholder='E.g. "202205"'
						inputProps={{
							maxLength: 6
						}}
					/>
				</Box>
				<LoadingButton 
					loading={unfinalizing} 
					onClick={batchUnfinalize}
					sx={{mt:2,}} 
					variant="contained" 
					fullWidth
				>Unfinalize</LoadingButton>
			</Paper>
		</Modal>
	);
}
export default SettingModal